import { useEffect, useRef, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import "../css/Navbar.css";

function Navbar() {

  const [menuOpen, setMenuOpen] = useState(false);
  const [mobileProductsOpen, setMobileProductsOpen] = useState(false);

  const navRef = useRef(null);
  const menuRef = useRef(null);

  const { hash } = useLocation();

  /* SCROLL TO HASH */
  useEffect(() => {

    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }

  }, [hash]);


  /* CLOSE MENU WHEN CLICK OUTSIDE */
  useEffect(() => {

    const handleOutsideClick = (event) => {

      if (
        menuOpen &&
        menuRef.current &&
        navRef.current &&
        !menuRef.current.contains(event.target) &&
        !navRef.current.contains(event.target)
      ) {
        setMenuOpen(false);
      }

    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => document.removeEventListener("mousedown", handleOutsideClick);

  }, [menuOpen]);


  /* RESET MENU ON DESKTOP */
  useEffect(() => {

    const handleResize = () => {

      if (window.innerWidth > 767) {
        setMenuOpen(false);
        setMobileProductsOpen(false);
      }

    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);

  }, []);


  useEffect(() => {
    if (!menuOpen) setMobileProductsOpen(false);
  }, [menuOpen]);


  return (
    <>

      {/* MOBILE MENU */}
      <div ref={menuRef} className={`mobile-menu ${menuOpen ? "open" : ""}`}>

        <NavLink to="/" onClick={() => setMenuOpen(false)}>
          Home
        </NavLink>

        <NavLink to="/#services" onClick={() => setMenuOpen(false)}>
          Services
        </NavLink>

        {/* MOBILE PRODUCTS */}
        <div className={`mobile-dropdown ${mobileProductsOpen ? "open" : ""}`}>

          <button
            className="mobile-dropdown-toggle"
            onClick={() => setMobileProductsOpen(!mobileProductsOpen)}
            type="button"
          >
            <span className="dropdown-link">Products</span>
            <span className="arrow">
              {mobileProductsOpen ? "−" : "+"}
            </span>
          </button>

          <div className="mobile-dropdown-menu">

            {/* PRODUCT PAGES COMMENTED FOR FUTURE */}
            {/*
            <NavLink to="/products/agriculture">Agriculture</NavLink>
            <NavLink to="/products/electric-mobility">Electric Mobility</NavLink>
            <NavLink to="/products/renewable-energy">Renewable Energy</NavLink>
            <NavLink to="/products/home-automation">Home Automation</NavLink>
            */}

            {/* CURRENT → SCROLL TO PRODUCTS */}
            <NavLink to="/#products" onClick={() => setMenuOpen(false)}>
              Agriculture
            </NavLink>

            <NavLink to="/#products" onClick={() => setMenuOpen(false)}>
              Electric Mobility
            </NavLink>

            <NavLink to="/#products" onClick={() => setMenuOpen(false)}>
              Renewable Energy
            </NavLink>

            <NavLink to="/#products" onClick={() => setMenuOpen(false)}>
              Home Automation
            </NavLink>

          </div>

        </div>


        <NavLink to="/#about" onClick={() => setMenuOpen(false)}>
          About Us
        </NavLink>

        <NavLink to="/careers" onClick={() => setMenuOpen(false)}>
          Careers
        </NavLink>

        <NavLink to="/#contact" onClick={() => setMenuOpen(false)}>
          Contact Us
        </NavLink>

      </div>



      {/* DESKTOP NAVBAR */}
      <nav className="navbar" ref={navRef}>

        {/* LOGO */}
        <div className="logo">
          <Link to="/" onClick={() => setMenuOpen(false)}>
            <img src="/icon/logo_name.png" alt="NXSA Logo" />
          </Link>
        </div>


        {/* NAV LINKS */}
        <div className="nav-links">

          <NavLink to="/">Home</NavLink>

          <NavLink to="/#services">
            Services
          </NavLink>


          {/* PRODUCTS DROPDOWN */}
          {/* <div className="nav-dropdown">

            <span className="dropdown-link">Products</span>

            <div className="dropdown-menu">

              {/* PRODUCT ROUTES COMMENTED */}
              {/*
              <NavLink to="/products/agriculture">Agriculture</NavLink>
              <NavLink to="/products/electric-mobility">Electric Mobility</NavLink>
              <NavLink to="/products/renewable-energy">Renewable Energy</NavLink>
              <NavLink to="/products/home-automation">Home Automation</NavLink>
              */}

              {/* CURRENT BEHAVIOR */}
              {/* <NavLink to="/#products">Agriculture</NavLink>
              <NavLink to="/#products">Electric Mobility</NavLink>
              <NavLink to="/#products">Renewable Energy</NavLink>
              <NavLink to="/#products">Home Automation</NavLink>

            </div>

          </div> */} 


          <NavLink to="/#products">
              Products
          </NavLink>



          <NavLink to="/#about">
            About Us
          </NavLink>

          <NavLink  to="/careers">
            Careers
          </NavLink>

        </div>


        {/* CONTACT BUTTON */}
        <NavLink to="/#contact" className="contact-btn">
          Contact Us
        </NavLink>


        {/* HAMBURGER */}
        <button
          className={`navbar-toggler ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
          type="button"
        >
          <span />
          <span />
          <span />
        </button>

      </nav>

    </>
  );
}

export default Navbar;